export const HelpPage = () => {
  return (
    <div style={{ maxHeight: "75%" }}>
      <h1>halp</h1>
      <p>
        Welcome to the <a href="https://optimem.org">Optimem</a> Editor v0.02
      </p>
      <p>
        This tool is a work in progress and not recommended for human
        consumption.
      </p>
      <p>
        If you have any questions, please ask in{" "}
        <a href="https://optimem.org/discord">the Discord</a>.
      </p>
      <h2>Connecting to phone</h2>
      <p>
        You can connect to your phone by going to Settings and then "Create/Edit Packs" in the app. Or, click on the "..." button on a pack, and then hit
        "Edit".
      </p>
      <p>
        Then, enter the connect code displayed in the top right of this editor
        and hit connect.
      </p>
      <p>
        <strong>The connection sometimes takes a few tries to connect.</strong> Try pressing the connect button a few times, or reloading the page, make sure the code is right,
        and it should eventually work.
      </p>
      <p>
        You can transfer packs bi-directionally. Press "Send" from the app, or "Send to device" from the editor, and hit accept, when you're ready to transfer.
      </p>
      <h2>Basics</h2>
      <p>
        Press "create new pack", or transfer a pack from your phone, to get an idea of how to create a pack.
      </p>
      <p>
        If you wish to change a pack without overwriting it, make sure to change the ID. If
        you keep the Pack ID the same, it will overwrite any existing pack when transferred back.
      </p>
      <p>
        You can use arrow keys, enter, and [shift+]tab to enter information faster.
      </p>
      <p>
        You should definitely <strong>SAVE OFTEN</strong>{" "}
        to your computer. This editor is not perfectly stable. You can
        lose data if you navigate away or there's an error.
      </p>
      <p>
        If there is an error on this page while you were editing, try opening up the
        Javascript console and type:{" "}
        <strong style={{ fontFamily: "monospace" }}>save()</strong>{" "}
        as a last ditch effort.
      </p>
      <h2>Attachments & media</h2>
      <p>
        You can attach media by creating a pack, then dragging and dropping the
        file on the attachments area.
      </p>
      <p>Currently audio (.wav, .mp3), images (.png, .jpg), and video (.mp4) are supported.</p>
      <p>
        To include the media in a card, type the name of the file+extension
        (e.g. my_sound.mp3) in the audio/image field. You can also type{" "}
        {"{{ID}}"}.mp3 to automatically use the card ID as the name.
      </p>
      <h2>Terminology & concepts</h2>
      <p>
        The editor creates <strong>packs</strong> of cards. Such as, a pack of
        {" "}
        <i>Spanish-English common words</i>.
      </p>
      <p>
        These cards are built from <strong>concepts</strong> (such as,{" "}
        <i>garden</i> or <i>sky</i>). Each card has a unique <strong>ID</strong>
        {" "}
        (like, <i>basketball</i>, <i>id1</i>, etc.).
      </p>
      <p>
        A concept can be represented in many different ways, and these
        representations are referred to as <strong>reps</strong>.
      </p>
      <p>
        Reps are all of the different ways the same concept can be expressed. In
        the above example, "garden" may have two reps: Spanish (<i>jardín</i>)
        and English (<i>garden</i>). Sky also has two reps: Spanish (<i>
          cielo
        </i>) and English (<i>sky</i>).
      </p>
      <p>
        Within each rep are <strong>fields</strong>. These can be{" "}
        <strong>text, audio, images</strong>. So for the above example, we were
        using text. However, we could also have used an image of a garden, or an
        audio clip of the spoken word.
      </p>
      <p>
        For each rep, there is a{" "}
        <strong>base rep</strong>. This lets you configure some common
        information of how all reps are displayed, like you may want to write
        {" "}
        <i>"Translate this to English"</i>{" "}
        for all Spanish–English translation questions.
      </p>
      <p>
        Last, is{" "}
        <strong>connections</strong>. This determines which flash cards or
        translations will be generated from the pack. For example, you may
        connect English → Spanish, and then people would see an English word and
        have to guess the Spanish translation. You can also connect things in
        both directions, so users translate both ways.
      </p>
      <h2>Miscellaneous</h2>
      <p>
        ID's must be unique. There's a small issue where if you have two IDs
        with a common prefix: "friend" and "friendly", the editor will drop the
        letter when you type it. You can figure out how to work around this.
      </p>
      <p>
        There is a "more options" menu in the top toolbar which lets you take
        bulk actions (like import and export lists of words).
      </p>
    </div>
  );
};
